import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Targeting = {
  Helmet: lazy(() => import('./components/Helmet')),
  DefaultValues: lazy(() => import('./DefaultValues')),
  ConfigsTargeting: lazyNamed(() => import('./KeywordsTargeting'), 'KeywordsTargeting'),
  KeywordsTargeting: lazy(() => import('./KeywordsTargeting/KeywordsTargetingForm')),
  Layout: lazy(() => import('./components/Layout')),
};

export default Targeting;
